export default "__VITE_ASSET__0mNLfvwu__"